import type { Channel, TravelEntryPage } from "@/api_client";
import { TravelEntryForm } from "@/components/products/travel/entry/TravelEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type TravelEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function TravelEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<TravelEntryProps>) {
  const {
    isLoading,
    isSubmitting,
    submitEntryHandler,
    policyHolder,
    user,
    content,
  } = useEntryForWebComponents<TravelEntryPage>({
    productType: "travel",
    backendHost,
    appPathPrefix,
    skipCart,
    channel,
    contentPageKey: "travelEntryPage",
    language,
  });

  if (isLoading) return <ProductContainer.Loader />;

  return (
    <TravelEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
